var paperlessLeafGreen = '#8BC34A';
var muiPaperlessLeaf16 = {
    paths: [
        {
            path: 'M16,0.374499739 C14.174337,5.15769075 11.7426486,8.42619872 8.70493473,10.1800237 C6.11091296,11.6776828 3.6398531,11.7446826 1.29175515,10.3810229 C1.6775739,9.68696739 2.17588912,8.92292747 2.78519097,8.08830841 C4.43473914,5.8287644 6.79970695,4.06472431 9.88009442,2.79618813 C8.36969592,3.0210411 6.57518494,3.86576211 4.49656148,5.33035117 C2.97806818,6.40027495 1.56093179,7.84672958 0.245152319,9.66971504 L0.0976624052,9.55571863 C-0.375934979,6.07484124 0.872940698,3.47664804 3.84428944,1.76113905 C6.81563818,0.0456300527 10.8675417,-0.41658305 16,0.374499739 Z',
            fill: paperlessLeafGreen,
        },
    ],
    title: 'Paperless Leaf',
    width: 16,
    height: 12,
};
var muiPaperlessLeaf24 = {
    paths: [
        {
            path: 'M24,0.49428189 C21.2094902,7.58827956 17.5341713,12.451674 12.9740432,15.0844652 C9.07955283,17.3329503 5.38787865,17.4648127 1.89902066,15.4800525 C2.48566108,14.4496745 3.24007756,13.313774 4.16118471,12.0720767 C6.65492217,8.710397 10.210475,6.07150574 14.8278432,4.15540289 C12.5691327,4.50793828 9.87781902,5.7804346 6.75390219,7.97289185 C4.47151122,9.57477202 2.33549082,11.731951 0.345840986,14.4444289 L0.127871292,14.2768618 C-0.532865418,9.13844262 1.36701757,5.28159681 5.82752025,2.70632439 C10.2880229,0.131051961 16.3455162,-0.606295538 24,0.49428189 Z',
            fill: paperlessLeafGreen,
        },
    ],
    title: 'Paperless Leaf',
    width: 24,
    height: 17,
};
var muiPaperlessLeaf = {
    base: muiPaperlessLeaf16,
    smIcon: muiPaperlessLeaf16,
    lgIcon: muiPaperlessLeaf24,
};
export { muiPaperlessLeaf };
//# sourceMappingURL=paperlessLeaf.js.map